/**
 * RESPONSIBILITY: draw the buttons under a band's words, the first as the main one.
 *
 * Draws NOTHING when there are none - not an empty wrapper - so a band on a page that has
 * never had buttons is exactly the markup it was before they existed. A button needs both
 * its words and its address; one without either is skipped rather than drawn dead.
 */
import { mapTarget } from '../map-link';
import type { BandData } from './kind';

export function BandButtons({ b, light = false }: { b: BandData; light?: boolean }) {
  const shown = (b.buttons ?? []).filter((x) => x.label && x.href);
  if (!shown.length) return null;

  return (
    <div className={light ? 'btns btns-centre' : 'btns'}>
      {shown.map((x, i) => (
        <a
          key={`${x.href}-${i}`} href={x.href} {...mapTarget(x.href!)}
          className={light ? (i === 0 ? 'btn btn-light' : 'btn btn-ghost-light') : (i === 0 ? 'btn' : 'btn btn-ghost')}
        >
          {x.label}
        </a>
      ))}
    </div>
  );
}
